<template>
  <div>
    <page-header has-return :page="pageHeaderConfig" />
    <filter-manager
      ref="filterRef"
      :filters="filtersConfig"
      :display-advanced="false"
      search-icon="fa fa-sync pr-2"
      search-text=""
      search-container-class="d-flex align-items-center justify-content-end"
      v-model="filterModel"
      @search="onProcessHandler"
    >
      <div class="col d-flex justify-content-end align-items-center">
        <dropdown
          icon="fas fa-print"
          :items="reportOptions"
          title="Seleccione"
        />
      </div>
    </filter-manager>
  </div>
</template>

<script>
//libs components
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import Dropdown from 'dropdown'

//services
import AcademicYearServices from '@/services/api/academicyear.api'
import RpServices from '@/services/api/rp.api.js'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js'

//constants
import codeAcademicYear from '@/utils/constants/codeAcademicYear.js'

export default {
  name: 'SpecialistExpiredLicenses',
  components: {
    PageHeader,
    FilterManager,
    Dropdown,
  },
  mixins: [alertMixin],
  data: () => ({
    filterOptions: {
      academicYears: [],
      providers: [],
    },
    filterModel: {
      academicYear: null,
      provider: null,
    },
  }),
  computed: {
    pageHeaderConfig() {
      return {
        icon: 'fas fa-chart-pie',
        title: 'Licencias Expiradas de Especialistas',
        routes: ['Inicio', 'Reportes', 'Licencias Expiradas de Especialistas'],
      }
    },
    userHasSingleCompany() {
      return this.userCompanies?.length === 1
    },
    userCurrentCompany() {
      return this.userHasSingleCompany ? this.userCompanies[0] : null
    },
    disabledFilterByProvider() {
      return this.userHasSingleCompany && !!this.filterModel.provider?.id
    },
    filtersConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Año Académico',
          error: 'El año académico es requerido.',
          validations: 'required',
          clearable: false,
          class: 'col-12 col-md-4',
          options: this.filterOptions.academicYears,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'provider',
          component: 'custom-drop-down',
          class: 'col-12 col-md-6',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Proveedor',
          error: 'El proveedor es requerido.',
          validations: 'required',
          options: this.filterOptions.providers,
          disabled: this.disabledFilterByProvider,
        },
      ]
    },
    reportOptions() {
      return [
        {
          label: 'Excel',
          icon: 'fas fa-print text-green',
          class: 'pr-1',
          visible: true,
          click: () => this.onProcessHandler(false),
        },
        {
          label: 'PDF',
          icon: 'fas fa-print text-green',
          class: 'pr-1',
          visible: true,
          click: () => this.onProcessHandler(true),
        },
      ]
    },
  },
  async mounted() {
    await this.getInitialFilters()
  },
  methods: {
    async getInitialFilters() {
      this.filterOptions.academicYears = (
        await AcademicYearServices.getAcademicYearsFromSpecificYear(
          codeAcademicYear['2016-2017']
        )
      ).data
    },
    async onChangeAcademicYear() {
      this.filterModel.provider = null
      this.filterOptions.providers = []

      await this.GetProvidersInAcademicYear()
    },
    async GetProvidersInAcademicYear() {
      this.filterOptions.providers = (
        await RpServices.getProviders(this.filterModel.academicYear.id)
      ).data

      this.filterModel = {
        ...this.filterModel,
        provider: this.userCurrentCompany,
      }
    },
    async onProcessHandler(isPdfFormat) {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        )
        return
      }

      await ReportServices.getReport('rpspecialistexpiredlicenses', {
        academicYearId: this.filterModel.academicYear.id,
        companyId: this.filterModel.provider.id,
        isServiceRequestCompany: true,
        isPdfFormat,
      }).then((res) => DocumentServices.Download(res.data))
    },
  },
}
</script>
